import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class ForumAnchor extends WebComponent {
  constructor(props) {
    super(props);
    this.anchor = this.anchor.bind(this);
  }

  didMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const anchorId = urlParams.get('anchorId');
    if (anchorId) this.anchor(urlParams.get('anchorId'));
  }

  anchor(id) {
    const self = this;
    let anchoredPost = this.element.querySelector(`#post-${id}`);
    if (!anchoredPost.classList.contains('forum__item--master')) {
      anchoredPost = anchoredPost.closest('.forum__item--master');
    }

    window.scrollTo({
      behavior: 'smooth',
      top:
        anchoredPost.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        100,
    });
    window.setTimeout(() => {
      anchoredPost.querySelector('.forum__btn-answer').click();
    }, 200);
  }
}

export default ForumAnchor;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumAnchor.js